// extracted by mini-css-extract-plugin
export var currencyDropdown = "_redotech-redo-return-app-lib-order-navbar-currency-dropdown";
export var currencyOption = "_redotech-redo-return-app-lib-order-navbar-currency-option";
export var currencyText = "_redotech-redo-return-app-lib-order-navbar-currency-text";
export var invisible = "_redotech-redo-return-app-lib-order-navbar-invisible";
export var mobile = "_redotech-redo-return-app-lib-order-navbar-mobile";